import React from 'react';
import {Grid} from '@material-ui/core';
import {SwitchCustom} from '../../../Core/UI';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

type FGPersonalProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    parameters: Approval;
    index: number;
};

const FGPersonal = observer(({valueChanged, setCategory, parameters, index}: FGPersonalProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );
    return (
        <CategoryCard title={'Personal History'} setCategory={setCategory} index={index}>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgAnyInsuranceDeclinedPostponedRescinded',
                        label: 'Has the proposed Insured ever had any insurance application declined, postponed, or rescinded; ever been offered rated or modified life insurance; ever been refused for renewal or reinstatement?',
                        ...parameters.fgAnyInsuranceDeclinedPostponedRescinded,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgAnyInsuranceDeclinedPostponedRescindedDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgTraveledResidedOutsideUSOrCanadaPast2YrOrPlanInNext2Yr',
                        label: 'Has the proposed Insured traveled or resided outside the United States or Canada within the past 2 years or plan to travel outside the United States or Canada in the next two years?',
                        ...parameters.fgTraveledResidedOutsideUSOrCanadaPast2YrOrPlanInNext2Yr,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgTraveledResidedOutsideUSOrCanadaPast2YrOrPlanInNext2YrDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgPleadedGuiltyBeenConvictedFelony',
                        label: 'Has the proposed Insured ever pleaded guilty or been convicted of a felony, have such charges currently pending, or is the proposed Insured currently on probation or parole?',
                        ...parameters.fgPleadedGuiltyBeenConvictedFelony,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgPleadedGuiltyBeenConvictedFelonyDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgMarijuanaPast5Years',
                        label: 'Has the proposed Insured used marijuana in any form in the past 5 years?',
                        ...parameters.fgMarijuanaPast5Years,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            {parameters.fgMarijuanaPast5Years.value && (
                <>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Marijuana: Product Used',
                                name: 'marijuanaProducts',
                                options: fieldOptions.marijuanaProducts.options,
                                ...parameters.marijuanaProducts,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Marijuana: Frequency Of Usage',
                                name: 'marijuanaFrequency',
                                options: fieldOptions.marijuanaFrequency.options,
                                ...parameters.marijuanaFrequency,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                inputVariant="outlined"
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label={required('Marijuana: Last Usage')}
                                style={{width: '100%', marginTop: 8}}
                                value={parameters.marijuanaLastUse?.value || null}
                                onChange={(date) => valueChanged(parameters.marijuanaLastUse, date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </>
            )}
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgHeroinCocaineNarcoticsBarbituratesAmphetaminesHallucinogensControlledSubstance',
                        label: 'Has the proposed Insured ever used heroin, cocaine, narcotics, barbiturates, amphetamines, hallucinogens, or any other controlled substance?',
                        ...parameters.fgHeroinCocaineNarcoticsBarbituratesAmphetaminesHallucinogensControlledSubstance,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={
                        parameters.fgHeroinCocaineNarcoticsBarbituratesAmphetaminesHallucinogensControlledSubstanceDetail
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgAlcoholDrugTreatment',
                        label: 'Has the proposed Insured ever been advised by a member of the medical profession to receive treatment or had treatment for alcohol use or drug dependency on prescribed or non-prescribed drugs?',
                        ...parameters.fgAlcoholDrugTreatment,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgAlcoholDrugTreatmentDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgDUIDWIPast5yrs',
                        label: 'In the past 5 years, has the proposed Insured pleaded guilty or been convicted of reckless driving or driving under the influence of alcohol or drugs (DUI, DWI); had a driver’s license suspended or revoked?',
                        ...parameters.fgDUIDWIPast5yrs,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgDUIDWIPast5yrsDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgMovingViolationsPast5Years',
                        label: 'In the past 5 years, has the proposed Insured pleaded guilty to or been convicted of any moving violations?',
                        ...parameters.fgMovingViolationsPast5Years,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgMovingViolationsPast5YearsDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgBankruptcyPast7Years',
                        label: 'In the past 7 years, has the proposed Insured filed for bankruptcy?',
                        ...parameters.fgBankruptcyPast7Years,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgBankruptcyPast7YearsDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgParticipateInRacingMountainClimbingScubaDivingBungeeJumpingHangGlidingSkydivingAerialSportsPast5YrsOrNext2Yrs',
                        label: 'Has the proposed Insured participated in the past 5 years, or intend to in the next 2 years, in any activity such as motorized vehicle racing, mountain or rock climbing, scuba diving, bungee jumping, hang gliding, skydiving, or any other aerial sports?',
                        ...parameters.fgParticipateInRacingMountainClimbingScubaDivingBungeeJumpingHangGlidingSkydivingAerialSportsPast5YrsOrNext2Yrs,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={
                        parameters.fgParticipateInRacingMountainClimbingScubaDivingBungeeJumpingHangGlidingSkydivingAerialSportsPast5YrsOrNext2YrsDetail
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgPilotStudentPilotCrewMemberPast5YearsOrNext2Years',
                        label: 'Has the proposed Insured flown in the past 5 years, or intend to in the next 2 years, as a pilot, student pilot, or crew member other than on a regularly scheduled commercial airline?',
                        ...parameters.fgPilotStudentPilotCrewMemberPast5YearsOrNext2Years,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgPilotStudentPilotCrewMemberPast5YearsOrNext2YearsDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgFinancingMortgageHomeEquityLoanPremiums',
                        label: 'Is the Owner and/or any proposed Insured financing or refinancing a mortgage and/or home equity loan or contemplating the use of any kind of mortgage financing strategy in connection with the purchase of or the payment of premiums on the life insurance policy?',
                        ...parameters.fgFinancingMortgageHomeEquityLoanPremiums,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgFinancingMortgageHomeEquityLoanPremiumsDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgBorrowMoneyPremium',
                        label: 'Will the Owner and/or any proposed Insured borrow money to pay the premium for the life insurance being applied for or have someone else pay these premiums in return for assigning part or all of the policy values to someone else?',
                        ...parameters.fgBorrowMoneyPremium,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={parameters.fgBorrowMoneyPremiumDetail}
                />
            </Grid>
            <Grid item xs={12}>
                <SwitchCustom
                    param={{
                        name: 'fgLifeInsuranceAnnuitySoldAssignedToLifeSettlementViaticalSecondaryMarketProvider',
                        label: 'Has the Owner and/or any proposed Insured ever had or currently have any life insurance or annuity benefit that has been sold or assigned to a life settlement, viatical or secondary market provider?',
                        ...parameters.fgLifeInsuranceAnnuitySoldAssignedToLifeSettlementViaticalSecondaryMarketProvider,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                    provideDetailParam={
                        parameters.fgLifeInsuranceAnnuitySoldAssignedToLifeSettlementViaticalSecondaryMarketProviderDetail
                    }
                />
            </Grid>
        </CategoryCard>
    );
});

export default FGPersonal;
